import setupAxios from "../config/axios";

/**
 * Shared Axios instance for app API calls.
 */
const axios = setupAxios();

export default axios;
